import $ from 'jQuery';
import './machine_app_filter_list.css';


export function filterList(renderList, inputTitleAttributeText) {
  function lOnFilter(pFilter) {
    renderList(pFilter);
    console.log(pFilter);
    pFilter.length ? lSearchSpan.hide() : lSearchSpan.show();
  }

  const lFilterContainer = $('<div>')
    .addClass('machineapp_filter_container');
  const lFilterWidget = $('<input>')
    .attr('title', `Filter ${inputTitleAttributeText}`)
    .on('input', function() { lOnFilter(lFilterWidget.val());})
    .addClass('machineapp_list_search');
  const lPlaceholderElement = $('<div>')
    .addClass('machineapp_list_container_filter_placeholder');
  const lSearchSpan = $('<span>')
    .text('Search');

  return lFilterContainer.append(
    lFilterWidget,
    lPlaceholderElement.append(
      $('<i>').addClass('far fa-search'),
      lSearchSpan
    )
  );
}